// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router, { composeWithStore } from './router'
import store from './store'
import './assets/rem'
import iView from 'iview'
import 'iview/dist/styles/iview.css'
import './assets/iview_my.css'
import Vuex from 'vuex'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'

Vue.config.productionTip = false

/* eslint-disable no-new */
Vue.use(iView)
Vue.use(Vuex)
Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999
  }
})
Viewer.setDefaults({
  'inline': false,
  'button': true, // 右上角按钮
  'navbar': false, // 底部缩略图
  'title': false, // 当前图片标题
  'toolbar': true, // 底部工具栏
  'tooltip': true, // 显示缩放百分比
  'movable': false, // 是否可以移动
  'zoomable': true, // 是否可以缩放
  'rotatable': true, // 是否可旋转
  'scalable': false, // 是否可翻转
  'transition': false, // 使用 CSS3 过度
  'fullscreen': true, // 播放时是否全屏
  'keyboard': true, // 是否支持键盘
  'loop': false, // 循环展示图片
  'url': 'data-source',
  ready: function (e) {
    console.log(e.type, '组件以初始化')
  },
  show: function (e) {
    console.log(e.type, '图片显示开始')
  },
  shown: function (e) {
    console.log(e.type, '图片显示结束')
  },
  hide: function (e) {
    console.log(e.type, '图片隐藏完成')
  },
  hidden: function (e) {
    console.log(e.type, '图片隐藏结束')
  },
  view: function (e) {
    console.log(e.type, '视图开始')
  },
  viewed: function (e) {
    console.log(e.type, '视图结束')
  },
  zoom: function (e) {
    console.log(e.type, '图片缩放开始')
  },
  zoomed: function (e) {
    console.log(e.type, '图片缩放结束')
  }
})

composeWithStore(store)

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js